import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Tue Oct 23 2018
 * @author PSe
 * @author Tomáš Leity
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { Overview, Pagination, Promotion, PromotionFilter } from '@logio/common-be-fe';
import { Map as ImmutableMap } from 'immutable';
import { action, observable, runInAction } from 'mobx';
import { PromotionLayer } from '../../transportLayers/promotion/PromotionLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
/**
 * Persistent store for Promotions
 */

export var PromotionStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(PromotionStore, _BaseStore);

  function PromotionStore() {
    var _this;

    _classCallCheck(this, PromotionStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionStore).apply(this, arguments));
    /** Store name */

    _this.name = StoreName.Promotion;
    /** Layer contains methods for fetching data */

    _this.promotionLayer = new PromotionLayer();
    /** List of Promotions */

    _this.list = ImmutableMap();
    _this.listOverview = new Overview(PromotionFilter.EMPTY, null, null, new Pagination(PromotionStore.PAGE_SIZE, 0, null));
    /** List of change history sets for Promotion */

    _this.changeHistoryList = new Map();
    /**
     * Fetches all Promotions
     * @returns a promise with Map of all Promotions
     */

    _this.getAll = function () {
      return _this.promotionLayer.findAll().then(function (promotions) {
        _this.list = _this.list.clear();
        runInAction(function () {
          promotions.forEach(function (promotion) {
            _this.list = _this.list.set(promotion.id, promotion);
          });
        });
        return promotions;
      });
    };
    /**
     * Fetches one Promotion
     * @returns a promise with Promotion
     * @param id
     */


    _this.getOne = function (id) {
      return _this.promotionLayer.findOne(id).then(function (promotion) {
        runInAction(function () {
          _this.list = _this.list.set(promotion.id, promotion);
        });
        return promotion;
      });
    };
    /**
     * Creates new Promotion using PromotionLayer
     * @param promotion - new Promotion
     * @param open - open state
     */


    _this.create = function (promotion) {
      var open = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.promotionLayer.createPromotion(promotion, open).then(function (createdPromotion) {
        runInAction(function () {
          _this.list = _this.list.set(createdPromotion.id, createdPromotion);
        });
        return createdPromotion;
      });
    };
    /**
     * Updates Promotion using PromotionLayer
     * @param promotion - Promotion that you want to update
     */


    _this.update = function (promotion) {
      return _this.promotionLayer.update(promotion).then(function (updatedPromotion) {
        runInAction(function () {
          _this.list = _this.list.set(updatedPromotion.id, updatedPromotion);
        });
        return updatedPromotion;
      });
    };
    /**
     * Fetches filtered Promotions based on the filter.
     * @param filter - filter params
     * @param pageNum
     * @param checkPrivileges
     * @param customLimit
     * @returns a promise with all filtered Promotions
     */


    _this.filter = function (filter, pageNum) {
      var checkPrivileges = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var customLimit = arguments.length > 3 ? arguments[3] : undefined;
      var limit = customLimit ? customLimit : PromotionStore.PAGE_SIZE;
      var pagination = new Pagination(limit, limit * (pageNum - 1), null);
      var overview = new Overview(filter, null, null, pagination);
      return _this.promotionLayer.filter(overview, checkPrivileges).then(function (response) {
        runInAction(function () {
          _this.list = _this.list.clear();
          response.result.forEach(function (promotion) {
            _this.list = _this.list.set(promotion.id, promotion);
          });
          _this.listOverview = response.overview;
        });
      });
    };
    /**
     * Deletes Promotion using PromotionLayer
     * @param id - id of the Promotion you want to delete.
     */


    _this.delete = function (id) {
      return _this.promotionLayer.delete(id).then(function () {
        runInAction(function () {
          _this.list = _this.list.delete(id);
        });
      });
    };
    /**
     * Fetches change history set info based on promotionId
     * @param promotionId
     * @returns a promise with all entity changes
     */


    _this.changeHistory = function (promotionId) {
      return _this.promotionLayer.changeHistory(promotionId).then(function (changes) {
        _this.changeHistoryList.clear();

        runInAction(function () {
          changes.forEach(function (change) {
            _this.changeHistoryList = _this.changeHistoryList.set(change.id, change);
          });
        });
        return changes;
      });
    };
    /**
     * Locks one particular item based on Window id
     * @param id
     */


    _this.lockPromotion = function (id) {
      return _this.promotionLayer.lockPromotion(id);
    };
    /**
     * Unlocks one particular item based on Window id
     * @param id
     */


    _this.unlockPromotion = function (id) {
      return _this.promotionLayer.unlockPromotion(id);
    };
    /**
     * Fetches overview of Promotions based on filter
     * @param filter
     */


    _this.overview = function (filter) {
      return _this.promotionLayer.overview(filter);
    };

    return _this;
  }
  /**
   * Fetches Promotion detail
   * @returns a promise with Promotion
   * @param id
   */


  _createClass(PromotionStore, [{
    key: "getPromotionDetail",
    value: function getPromotionDetail(id) {
      var _this2 = this;

      return this.promotionLayer.findOne(id).then(function (promotion) {
        runInAction(function () {
          _this2.detail = promotion;
        });
        return promotion;
      });
    }
  }, {
    key: "getSimulated",

    /**
     * Fetches all Promotions that are suitable for Forecast Simulation
     * FIXME: filter should be of type PromotionFilter
     * @returns a promise with Map of Promotions
     */
    value: function getSimulated(filter) {
      var _this3 = this;

      return this.promotionLayer.getSimulated(filter).then(function (promotions) {
        runInAction(function () {
          _this3.list = _this3.list.clear();
          promotions.forEach(function (promotion) {
            _this3.list = _this3.list.set(promotion.id, promotion);
          });
        });
        return promotions;
      });
    }
  }]);

  return PromotionStore;
}(BaseStore);
PromotionStore.PAGE_SIZE = 1000;

__decorate([observable, __metadata("design:type", Promotion)], PromotionStore.prototype, "detail", void 0);

__decorate([observable, __metadata("design:type", Object)], PromotionStore.prototype, "list", void 0);

__decorate([observable, __metadata("design:type", Overview)], PromotionStore.prototype, "listOverview", void 0);

__decorate([observable, __metadata("design:type", Map)], PromotionStore.prototype, "changeHistoryList", void 0);

__decorate([observable, __metadata("design:type", Object)], PromotionStore.prototype, "portionInfo", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", Promise)], PromotionStore.prototype, "getPromotionDetail", null);